import { render } from "./App.vue?vue&type=template&id=03119aae"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=03119aae&lang=css"

import exportComponent from "C:\\Project\\VuePro\\yitongkanglian\\yitongkanglian-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__